export default __webpack_public_path__ + "static/properties/20251128-051225.630/shared_it.properties";